import { useContext, useEffect, useState } from 'react';
import RepairingContext from '../../../../context/RepairingContext/RepairingContext';
import { useMutation } from 'react-query';
import { getDetailsRepairOrderPrint, paymentRepairOrder } from '../../../../Apis/repairingApi/RepairingApi';
import JsBarcode from 'jsbarcode';
import { Invoice } from './Invoice';
import { ToastMessage } from '../../../../utils/Helper';
import { IconButton, Tooltip } from '@mui/material';
import { Printer } from 'react-feather';

const RepairPayment = ({ barcodeRef }) => {
   const { id, setId, setPaymentModal } = useContext(RepairingContext);
   const [productData, setProductData] = useState(null);
   const [paymentForm, setPaymentForm] = useState({
      amount: '',
      method: 'Cash'
   });

   const emptyData = () => {
      setId('');
      setProductData(null);
      setPaymentForm({
         amount: '',
         method: 'Cash'
      });
      setPaymentModal(false);
   };

   const { mutate: handlePaymentRepairOrder, isLoading: paymentRepairOrderLoader } = useMutation(
      (formData) => paymentRepairOrder(formData),
      {
         onSuccess: (response) => {
            const productInvoice = { ...productData, ...response.data.payload };
            if (response.status === 200) {
               setPaymentModal(false);
               if (barcodeRef.current) {
                  JsBarcode(barcodeRef.current, response.data.payload.repairOrderId, {
                     format: 'CODE128',
                     lineColor: '#000',
                     width: 2,
                     height: 50,
                     displayValue: true
                  });
                  const printContent = barcodeRef.current.outerHTML;
                  document.getElementById('paymentReceipt').innerHTML = `${Invoice(productInvoice, printContent)}`;
                  window.print();
               }
               emptyData();
            }
         }
      }
   );

   // Pay Button Click
   const handlePayment = () => {
      if (!paymentForm.amount) {
         alert('Please enter an amount');
         return;
      }
      const payload = {
         amount: Number(paymentForm.amount),
         paymentMethod: paymentForm.method,
         repairOrderId: id
      };
      handlePaymentRepairOrder(payload);
   };

   const { mutate: repairingOrderDetails, isLoading } = useMutation(() => getDetailsRepairOrderPrint(id), {
      onSuccess: (response) => {
         if (response.status === 200) {
            const payload = response.data.payload.data;
            // Only storing needed fields
            setProductData({
               productType: payload.productType,
               makeModal: payload.makeModal,
               imeiNo: payload.imeiNo,
               estimateCost: payload.estimateCost,
               depositPaid: payload.depositPaid,
               network: payload.network,
               customerName: payload.customer?.name,
               customerPhone: payload.customer?.dialCode + ' ' + payload.customer?.phone,
               invoices: payload.invoices || []
            });
         }
      },
      onError: (error) => {
         const { status, message } = error?.response?.data || error;
         ToastMessage(status || 1, message);
         emptyData();
      }
   });

   const handlePaymentRecipe = (invoice) => {
      const productInvoice = { ...productData, ...invoice };
      if (barcodeRef.current) {
         JsBarcode(barcodeRef.current, id, {
            format: 'CODE128',
            lineColor: '#000',
            width: 2,
            height: 50,
            displayValue: true
         });
         const printContent = barcodeRef.current.outerHTML;
         document.getElementById('paymentReceipt').innerHTML = `${Invoice(productInvoice, printContent)}`;
         window.print();
      }
   };

   useEffect(() => {
      if (id) repairingOrderDetails();
   }, [id]);

   if (isLoading || !productData || paymentRepairOrderLoader) return <div>Loading...</div>;

   return (
      <div style={{ padding: '15px' }}>
         {/* PRODUCT BASIC INFO */}
         <div
            style={{
               border: '1px solid #ddd',
               borderRadius: '8px',
               padding: '12px',
               marginBottom: '20px'
            }}>
            {/* FLEX WRAPPER */}
            <div
               style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: '20px',
                  flexWrap: 'wrap'
               }}>
               {/* CUSTOMER INFO */}
               <div style={{ flex: '1 1 250px' }}>
                  <h5 style={{ marginBottom: '10px' }}>Customer Information</h5>
                  <p>
                     <strong>Name:</strong> {productData.customerName}
                  </p>
                  <p>
                     <strong>Phone:</strong> {productData.customerPhone}
                  </p>
               </div>
               {/* PRODUCT INFO */}
               <div style={{ flex: '1 1 250px' }}>
                  <h5 style={{ marginBottom: '10px' }}>Product Information</h5>

                  <p>
                     <strong>Product Type:</strong> {productData.productType}
                  </p>
                  <p>
                     <strong>Model:</strong> {productData.makeModal}
                  </p>
                  <p>
                     <strong>IMEI:</strong> {productData.imeiNo}
                  </p>
                  <p>
                     <strong>Estimated Cost:</strong> {productData.estimateCost}
                  </p>
                  <p>
                     <strong>Deposit Paid:</strong> {productData.depositPaid}
                  </p>
               </div>
            </div>
         </div>
         {/* ---------------- NEW PAYMENT ROW ---------------- */}
         <div
            style={{
               border: '1px solid #ddd',
               borderRadius: '8px',
               padding: '12px',
               marginBottom: '20px'
            }}>
            <h5>Add New Payment</h5>

            <div className='row g-3 mt-1'>
               <div className='col-md-4'>
                  <label className='form-label fw-bold'>Amount</label>
                  <input
                     type='number'
                     className='form-control'
                     value={paymentForm.amount}
                     onChange={(e) => setPaymentForm({ ...paymentForm, amount: e.target.value })}
                     placeholder='Enter amount'
                  />
               </div>

               <div className='col-md-4'>
                  <label className='form-label fw-bold'>Payment Method</label>
                  <select
                     className='form-select'
                     value={paymentForm.method}
                     onChange={(e) => setPaymentForm({ ...paymentForm, method: e.target.value })}>
                     <option value='Cash'>Cash</option>
                     <option value='UPI'>UPI</option>
                  </select>
               </div>

               <div className='col-md-4 d-flex align-items-end'>
                  <button className='btn btn-primary w-100' onClick={handlePayment}>
                     Pay Now
                  </button>
               </div>
               {/* ===== TOTAL PAID ===== */}
               <div className='col-12 mt-2'>
                  <div
                     style={{
                        padding: '10px',
                        border: '1px solid #ccc',
                        borderRadius: '6px',
                        background: '#f8f9fa'
                     }}>
                     {/* Calculate totals */}
                     {(() => {
                        const previousPaid = productData?.invoices?.reduce((sum, inv) => sum + inv.amount, 0) || 0;

                        const newAmount = Number(paymentForm.amount || 0);

                        const totalPaid = previousPaid + newAmount;

                        return (
                           <span>
                              Total Paid After This Payment: <strong style={{ color: '#7366ff' }}>{totalPaid}</strong>
                           </span>
                        );
                     })()}
                  </div>
               </div>
            </div>
         </div>
         {/* INVOICE DETAILS */}
         <div
            style={{
               border: '1px solid #ddd',
               borderRadius: '8px',
               padding: '12px',
               marginBottom: '20px'
            }}>
            <h4 style={{ marginBottom: '10px' }}>Payment History</h4>

            {productData.invoices.length === 0 ? (
               <p>No payments done yet.</p>
            ) : (
               <div className='table-responsive'>
                  <table className='table table-bordered table-striped'>
                     <thead className='table-light'>
                        <tr>
                           <th>#</th>
                           <th>Amount</th>
                           <th>Method</th>
                           <th>Status</th>
                           <th>Paid At</th>
                           <th>Payment Recipe</th>
                        </tr>
                     </thead>
                     <tbody>
                        {productData.invoices.map((inv, idx) => (
                           <tr key={inv.invoiceId}>
                              <td>{inv.invoiceId}</td>
                              <td>{inv.amount}</td>
                              <td>{inv.paymentMethod}</td>
                              <td>{inv.paymentStatus}</td>
                              <td>{new Date(inv.createdAt).toLocaleString()}</td>
                              <td>
                                 <Tooltip title='Payment Receipt'>
                                    <IconButton aria-label='receipt' onClick={() => handlePaymentRecipe(inv)}>
                                       <Printer style={{ color: 'rgb(10 198 0)' }} />
                                    </IconButton>
                                 </Tooltip>
                              </td>
                           </tr>
                        ))}
                     </tbody>
                  </table>
               </div>
            )}
         </div>
      </div>
   );
};

export default RepairPayment;
